import { Helmet } from "react-helmet-async";
import { useSiteConfig } from "../hooks/useSiteConfig";

export function ContactoPage() {
  const site = useSiteConfig();
  return (
    <>
      <Helmet>
        <title>Contacto — Campus EMJC</title>
      </Helmet>
      <section className="container-emjc py-20">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-orange-deep">
          Contacto
        </p>
        <h1 className="mt-2 max-w-3xl font-display text-5xl font-semibold leading-tight">
          Escríbenos.
        </h1>
        <div className="mt-10 grid gap-10 md:grid-cols-2">
          <div className="space-y-5 text-lg text-gray-700">
            <p>
              Si quieres saber más sobre matrículas, programas, fechas o sedes, escríbenos
              directamente a:
            </p>
            <a
              href={`mailto:${site.email}`}
              className="block break-all font-display text-3xl font-semibold text-brand-orange underline underline-offset-4 decoration-2 hover:decoration-[3px]"
            >
              {site.email}
            </a>
            <p>
              También puedes seguirnos en{" "}
              <a className="text-brand-orange-deep underline underline-offset-4 decoration-2 hover:decoration-[3px]" href={site.social.facebook.url} target="_blank" rel="noreferrer">
                Facebook
              </a>{" "}
              o en{" "}
              <a className="text-brand-orange-deep underline underline-offset-4 decoration-2 hover:decoration-[3px]" href={site.social.instagram.url} target="_blank" rel="noreferrer">
                Instagram
              </a>
              .
            </p>
          </div>
          <aside className="rounded-2xl bg-white p-8 ring-1 ring-gray-300">
            <h2 className="font-display text-2xl font-semibold">¿Eres una institución?</h2>
            <p className="mt-3 text-gray-700">
              Si representas a un ayuntamiento, diputación o centro educativo y quieres llevar la
              EMJC a tu localidad, escríbenos a la misma dirección y te enviaremos el dossier del
              proyecto.
            </p>
          </aside>
        </div>
      </section>
    </>
  );
}
